module.exports = __webpack_public_path__ + "img/GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip600mm.a0ea3475.png";